import { render, staticRenderFns } from "./ui-form-fromarchetype.vue?vue&type=template&id=0c9eaf5a&"
import script from "./ui-form-fromarchetype.vue?vue&type=script&lang=js&"
export * from "./ui-form-fromarchetype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports